export default __webpack_public_path__ + "static/media/RoboticArmAssembly@3x.a6d640c6.png";